@for (ref of newRefs(); track ref) {
  @if (commentView()) {
    <app-comment [ref]="ref"
                 [showLoadMore]="showLoadMore()"
                 [depth]="depth()"
                 [context]="context()" />
  } @else {
    <app-ref [ref]="ref"
             [class.thread]="true"
             [showToggle]="false"
             [expanded]="true"
             [expandInline]="true" />
  }
}
@if (depth() > 0) {
  @for (ref of list(); track ref) {
    @if (commentView()) {
      <app-comment [ref]="ref"
                   [showLoadMore]="showLoadMore()"
                   [depth]="depth()"
                   [context]="context()" />
    } @else {
      <app-ref [ref]="ref"
               [class.thread]="true"
               [showToggle]="false"
               [expanded]="true"
               [expandInline]="true" />
    }
  }
}
